import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; // Ensure this CSS file includes the new styles

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Amruta Travels Pvt Ltd - Terms & Conditions</title>
        <meta name="description" content="Terms & Conditions of Amruta Travels Pvt Ltd" />
      </Helmet>
      
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">Terms & Conditions</h2>
          </div>
        </div>
      </section>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> All bookings are subject to availability and will be confirmed once full payment is received along with issuance of a booking reference.</p>

                <p><b className="highlight">2. Payment:</b> Full payment must be made at the time of booking. Payments can be completed online or at our authorized offices.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Cancellations and rescheduling requests are subject to our cancellation policy. Charges may apply depending on timing.</p>

                <p><b className="highlight">4. Passenger Responsibility:</b> Passengers must carry valid identification and travel documents. Amruta Travels reserves the right to deny boarding without proper documentation.</p>

                <p><b className="highlight">5. Baggage Policy:</b> Baggage allowances are limited as per the ticket. Additional baggage may incur extra fees.</p>

                <p><b className="highlight">6. Travel Insurance:</b> We strongly recommend passengers purchase travel insurance to protect against unforeseen events.</p>

                <p><b className="highlight">7. Safety Regulations:</b> Passengers are required to follow all safety rules and instructions given by Amruta Travels staff.</p>

                <p><b className="highlight">8. Changes to Itinerary:</b> Amruta Travels reserves the right to modify itineraries in case of unforeseen circumstances or operational requirements.</p>

                <p><b className="highlight">9. Refusal of Service:</b> Service may be refused to passengers who exhibit disruptive behavior or violate company policies.</p>

                <p><b className="highlight">10. Jurisdiction:</b> These terms are governed by Indian law, and any disputes will be subject to the jurisdiction of Pune courts.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Please book services via our official website or through our customer service centers.</p>
                <p><b className="highlight">Customer Service:</b> Our support team is available to assist with any questions or special requests.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">Cancellation Fees:</b> Applicable fees will be charged based on the cancellation timing.</p>
                <p><b className="highlight">Refund Process:</b> Refunds will be made to the original payment method within a reasonable timeframe.</p>
                <p><b className="highlight">No-Show Policy:</b> No-shows may not be eligible for any refund or rescheduling.</p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions regarding our terms, please contact us:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+918010014995">+91 8010014995</a></li>
              <li><b>Email:</b> <a href="mailto:booking@amrutatravelspvtltd.com">booking@amrutatravelspvtltd.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
